import iconRange200Plus from './../images/icon-dollar-range-200-plus.svg';
import iconRange200PlusHover from './../images/icon-dollar-range-200-plus-white.svg';
import iconRange150_199 from './../images/icon-dollar-range-150-199.svg';
import iconRange150_199Hover from './../images/icon-dollar-range-150-199-white.svg';
import iconRange100_149 from './../images/icon-dollar-range-100-149.svg';
import iconRange100_149Hover from './../images/icon-dollar-range-100-149-white.svg';
import iconRange0_99 from './../images/icon-dollar-range-0-99.svg';
import iconRange0_99Hover from './../images/icon-dollar-range-0-99-white.svg';

const icons = [
  { name: 'range_200_plus', path: iconRange200Plus },
  { name: 'range_200_plus_hover', path: iconRange200PlusHover },
  { name: 'range_150_199', path: iconRange150_199 },
  { name: 'range_150_199_hover', path: iconRange150_199Hover },
  { name: 'range_100_149', path: iconRange100_149 },
  { name: 'range_100_149_hover', path: iconRange100_149Hover },
  { name: 'range_0_99', path: iconRange0_99 },
  { name: 'range_0_99_hover', path: iconRange0_99Hover },
];

export default icons;
